import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import SEO from "../../common-components/SEO";

export const Placement = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  // Static recruiters logo array
  const recruiter = [
     { image: "/assets/images/placement/1.webp" },
    { image: "/assets/images/placement/2.webp" },
    { image: "/assets/images/placement/3.webp" },
    { image: "/assets/images/placement/4.webp" },
    { image: "/assets/images/placement/5.webp" },
    { image: "/assets/images/placement/6.webp" },
    { image: "/assets/images/placement/7.webp" },
    { image: "/assets/images/placement/8.webp" },
    { image: "/assets/images/placement/9.webp" },
    // { image: "/assets/images/placement/10.webp" },
    { image: "/assets/images/placement/11.webp" },
    { image: "/assets/images/placement/12.webp" },
    { image: "/assets/images/placement/13.webp" },
    { image: "/assets/images/placement/14.webp" },
    { image: "/assets/images/placement/15.webp" },
    { image: "/assets/images/placement/16.webp" },
    { image: "/assets/images/placement/17.webp" },
    // { image: "/assets/images/placement/18.webp" },
    { image: "/assets/images/placement/19.webp" },
        { image: "/assets/images/placement/20.webp" },
    // Add more logos as needed
  ];
  return (
    <>
      {/* Add SEO Tags */}
      <SEO
        fullTitle={"Placements — McGAN'S Ooty School of Architecture | Recruiters & Career Support"}
        description={"Explore placement support at McGAN'S Ooty School of Architecture — internships, mentorship and industry connect for B.Arch and M.Arch students."}
        keywords={`placements, architecture placements, recruiters, internships, career cell, McGAN'S Ooty, architecture careers, placement support`}
        image={"https://mcgansarch.com/assets/images/placement/1.webp"}
        url={"https://mcgansarch.com/placement"}
      />

      <h1 style={{ display: "none" }}>
        Best Architecture College Placements in Tamil Nadu at McGAN’S Ooty
      </h1> 
      {/* Start Page Banner */}
      <div className="page-banner-area bg-1">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">Placement</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Placement</li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Banner */}

      {/* <!--Start Academic Details Area--> */}
      <div className="academics-details-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="academics-details">
                <div className="details">
                  <h2>
                    Welcome to the Placement Cell of Mcgans Ooty school of
                    Architecture
                  </h2>
                  <p>
                    With industry
connections,
personalized mentorship,
and rigorous training, we
empower our students to
turn their aspirations into
reality. Whether it's
landing dream
internships, acing
interviews, or building
professional networks,
we're with them
                  </p>
                </div>
                <div class="regiStartion-and-fee">
                  <h3>Services Offered</h3>
                  <div class="list">
                    <ul>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                        Career Counseling : Personalized guidance to help
                        students identify their strengths and career interests.
                      </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                        Resume Building : Workshops and individual sessions to
                        craft professional and impactful resumes.
                      </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                        Interview Preparation : Mock interviews and training
                        sessions to enhance interview skills and confidence.
                      </li>
                      {/* <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i> Or
                        Industry Interaction : Regular seminars, webinars, and
                        networking events with industry professionals.
                      </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i> Or
                        Internship Assistance : Support in securing internships
                        that provide practical experience and industry exposure.
                      </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i> Or
                        Job Placement : Assistance in finding suitable job
                        opportunities in top firms and organizations.
                      </li> */}
                    </ul>
                  </div>
                </div>
                {/* <!-- Start Academic Area --> */}
                <div className="academic-area pt-60 pb-70">
                  <div className="container">
                    <div className="text-center">
                      <h2 className="text-start">Recruitment Process</h2>
                      <p className="text-start">
                        Our placement process is designed to be seamless and
                        efficient for both students and recruiters. The process
                        includes.
                      </p>
                    </div>
                    <div className="row justify-content-center mt-5">
                      <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="200"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum3.webp"
                              width={50}
                              height={50}
                              title="McGAN’S Ooty Placement Services"
                              alt="McGAN’S Ooty Placement Services"
                            />
                            <h3>Registration</h3>
                          </div>
                          <p>
                            Students register with the Placement Cell and submit
                            their resumes.
                          </p>
                        </div>
                      </div>
                       <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="600"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum2.webp"
                              width={50}
                              height={50}
                              title="Architecture Internships Tamil Nadu"
                              alt="Architecture Internships Tamil Nadu"
                            />
                            <h3>Pre-Placement Talks</h3>
                          </div>
                          <p>
                            Recruiters conduct pre-placement talks to provide
                            insights into their organizations and job roles.
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="400"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum5.webp"
                              width={50}
                              height={50}
                              title="Architecture Internships Tamil Nadu"
                              alt="Architecture Internships Tamil Nadu"
                            />
                            <h3>Aptitude Tests</h3>
                          </div>
                          <p>
                            Companies may conduct aptitude tests to shortlist
                            candidates.
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="600"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum.webp"
                              width={50}
                              height={50}
                              title="Best Architecture College Placements in Tamil Nadu"
                              alt="Best Architecture College Placements in Tamil Nadu"
                            />
                            <h3>Group Discussions</h3>
                          </div>
                          <p>
                            Shortlisted candidates participate in group
                            discussions on relevant topics.
                          </p>
                        </div>
                      </div>
                       <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="600"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum4.webp"
                              width="50px"
                              height="45px"
                              title="Leading Recruiters for Architecture Students"
                              alt="Leading Recruiters for Architecture Students"
                            />
                            <h3>Personal Interviews</h3>
                          </div>
                          <p>
                            Final interviews are conducted by the recruiting
                            companies.
                          </p>
                        </div>
                      </div>
                     
                      <div
                        className="col-lg-4 col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay="600"
                        data-aos-once="true"
                      >
                        <div className="single-academics-card">
                          <div className="academic-top-content text-center">
                            <img
                              src="assets/images/curriculum/curriculum4.webp"
                              width="50px"
                              height="50px"
                              title="Job Placements for Architecture Graduates"
                              alt="Job Placements for Architecture Graduates"
                            />
                            <h3>Offer Letters</h3>
                          </div>
                          <p>
                            Successful candidates receive offer letters and
                            guidance on joining formalities.
                          </p>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
                {/* <!-- End Academic Area --> */}
                {/* <!-- Start Academic Area --> */}
                <div className="academic-area pb-71">
                  <div className="container">
                    <div className="text-center">
                      <h2 className="text-start">Our Students Placed in</h2>
                      <p className="text-start">
                        We have a strong network of industry partners and recruiters who frequently visit our campus for placement drives. Many of our students have been successfully placed in reputed organizations such as…
                      </p>
                    </div>
                    <div className="row justify-content-left mt-5">
                      {recruiter.length > 0 ? (
                        recruiter.map((item, index) => (
                          <div
                            className="col-lg-2 col-md-6"
                            data-aos="fade-up"
                            key={index}
                          >
                            <div className="academic-top-content text-center">
                              <img
                                src={item.image}
                                width={162}
                                height={162}
                                className="recruiter-logo"
                                title="Architecture Colleges with Highest Placements"
                                alt="Recruiter Logo"
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No placements available at the moment.</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* <!-- End Academic Area --> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .recruiter-logo {
          object-fit: contain;
          display: block;
        }
        @media (max-width: 768px) {
          .recruiter-logo { width: 120px; height: 120px; }
        }
      `}</style>

      {/* <!--End Academic Details Area--> */}
    </>
  );
};
